import { Injectable } from '@angular/core';
import { currentTab } from '@/app/current-tab';

@Injectable({
  providedIn: 'root'
})
export class CurrentTabInitializer {
  init() {
    currentTab.init();
    const multipleTabsInLocalStorage = localStorage.getItem('multipleTabs');
    if (!['true', 'false'].includes(multipleTabsInLocalStorage)) {
      localStorage.setItem('multipleTabs', 'true');
    }
  }
}
